/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import styles from './index.module.scss';

const BlankLayout = ({
  component: Component,
  user,
  ...props
}) => (
  <Route
    {...props}
    render={(matchProps) => (
      <div className={styles.root}>
        <div className={styles.container}>
          <Component {...matchProps} user={user} />
        </div>
      </div>
    )}
  />
);

BlankLayout.defaultProps = {
  user: {},
};

BlankLayout.propTypes = {
  component: PropTypes.any.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state && state.auth && state.auth.get('user') && state.auth.get('user').toJS(),
});

/*
const mapDispatchToProps = (dispatch) => ({

});
*/

export default connect(
  mapStateToProps,
  null, // mapDispatchToProps
)(BlankLayout);
